
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120-120v-720h80v720h-80zm640 0v-720h80v720h-80zM280-440v-80h80v80h-80zm160 320v-80h80v80h-80zm0-160v-80h80v80h-80zm0-160v-80h80v80h-80zm0-160v-80h80v80h-80zm0-160v-80h80v80h-80zm160 320v-80h80v80h-80z"}})])
          )
        }
      }
    